import React, { useState, useEffect } from "react";
import { Stack, Typography, Chip, Box } from "@mui/material";
import AppDialog from "component/ui/AppDialog";

const BulkApproveDialog = ({ open, onClose, onConfirm, loading = false, options = [7, 15, 30, 60, 90, 180] }) => {
  const [selectedDays, setSelectedDays] = useState(null);

  useEffect(() => {
    if (!open) {
      setSelectedDays(null);
    }
  }, [open]);

  const handleConfirm = () => {
    if (!selectedDays) return;
    onConfirm(selectedDays);
  };

  return (
    <AppDialog
      open={open}
      onClose={onClose}
      title="Approve Completed Tickets in Bulk"
      subtitle="Choose how far back you want to approve completed tickets. All completed tickets completed on or before the selected window will be sent for bulk approval."
      primaryLabel="Approve"
      secondaryLabel="Cancel"
      primaryDisabled={!selectedDays}
      primaryLoading={loading}
      onPrimary={handleConfirm}
    >
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          gap: 1,
          mb: 2,
        }}
      >
        {options.map((days) => (
          <Chip
            key={days}
            label={`${days} days`}
            clickable
            color={selectedDays === days ? "primary" : "default"}
            variant={selectedDays === days ? "filled" : "outlined"}
            onClick={() => setSelectedDays(days)}
          />
        ))}
      </Box>

      <Stack spacing={0.5}>
        <Typography variant="body2">
          The process runs in the background. You can continue working while tickets are being approved.
        </Typography>
      </Stack>
    </AppDialog>
  );
};

export default BulkApproveDialog;

